export default "__VITE_ASSET__9a0a9f71__"